export default {
  token: '3b4af60e1ad04a871836b04b386dbaa4',
  id: 692488,
  locales: ['en', 'nl', 'fr'/* , 'de', 'cs'*/],
  path: './src/shared/assets/lang/',
  libraries: {
    moment: {
      map: locale => locale === 'nl' ? 'nl-be' : locale,
      path: locale => locale !== 'en' && `moment/dist/locale/${locale}`,
    },
    numeral: {
      map: locale => locale === 'nl' ? 'nl-be' : locale,
      path: locale => locale !== 'en' && `numeral/locales/${locale}`,
    },
  },
};
